<template>
  <div>
    <div class="btn-cloud-wrapper" @mouseenter="onMouseEnter(jumpCard.type)" @mouseleave="onMouseLeave">
      <div class="btn-cloud-album" :style="{ backgroundImage: `url(${jumpCard.img})` }" />
      <div class="btn-cloud-qr" v-show="isShowQr">
        <div ref="qrcode" class="qrcode" />
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2'
import { rseat_pingback as rseatPingback } from '@iqiyi-h5act/act-pingSdk'

export default {
  props: {
    jumpCard: {
      type: Object,
      default: () => {
        return {
          type: 'album',
          text: '云相册',
          img: 'http://pic0.iqiyipic.com/common/20201014/1602642766.png',
          url: 'https://bud.m.iqiyi.com/community/tag?tagId=9652372727601112',
        }
      },
    },
  },
  data() {
    return {
      isShowQr: false,
      qrCode: null,
    }
  },
  watch: {
    jumpCard: {
      handler: function dataHandler(next) {
        this.jumpCard = next
      },
      deep: true,
    },
  },
  mounted() {},
  methods: {
    getQr() {
      if (!this.qrCode) {
        this.qrCode = new QRCode(this.$refs.qrcode, {
          width: 110,
          height: 110,
          text: this.jumpCard.url, // 二维码地址
        })
      }
    },
    onMouseEnter(type) {
      // 获取展示二维码
      this.$nextTick(() => this.getQr())
      this.isShowQr = true
      rseatPingback({
        rpage: 'carnival_page', // 由业务方定义的rpage值，如业务方不定义传递 'activity'
        block: 'carnival_block', // rseat 对应的block
        rseat: `click_carnival_${type}`,
      })
    },
    onMouseLeave() {
      this.isShowQr = false
    },
  },
}
</script>
<style lang="less">
.btn-cloud-wrapper {
  position: relative;
  .btn-cloud-qr {
    position: absolute;
    right: -180px;
    top: 50%;
    transform: translateY(-50%);
    width: 170px;
    height: 156px;
    background: transparent url('~@/assets/carnival2020/city-info/qr-bg.png') center center no-repeat;
    .qrcode {
      margin-left: 35px;
      margin-top: 24px;
    }
  }
  .btn-cloud-album {
    width: 379px;
    height: 126px;
    background: transparent url('~@/assets/carnival2020/city-info/cloud-album-big.png') center center no-repeat;
    background-size: 100% auto;
    background-position: center center;
    cursor: pointer;
  }
}
</style>
